import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Typography, Button, Stack } from '@mui/material';
import { StyledDiv, StyledIndexContainerDiv, StyledLeadContainer } from '../../Components/Styled/index';
import { privateRoutesPath } from '../../Routes';
import { GridRowModes } from '@mui/x-data-grid';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { createRequestData, dateFormatting, getEntityColumns, isValidEmail, updateRequestData } from '../../Utility/apiHelper';
import DataGridTable from '../../Components/DataGrid';
import SearchCustomer from './SearchCustomer';
import { useDispatch, useSelector } from 'react-redux';
import { customerIdWidth, emailWidth, handleValidateCodevalue, nameWidth, phoneCountryCodes, phoneWidth, searchEntity, STATIC_ENTITY_CONFIG, statusWidth, whocolumnWidth } from '../../Utility/constant';
import BiztantuSearch from '../../Components/BiztantuSearch';
import { requestGetCustomersPaged } from '../../Store/Customer/action';
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import SendNotification from '../../Components/SendNotification';
import { resetState } from '../../Utility/resetSearchFunction';
import BiztantuLoader from '../../Components/Loader';
import { setSearch } from '../../Store/SearchReducer/action';
import { usePaginatedSearch } from '../../Utility/hooks/usePaginatedSearch';
import { useSearchExecutor } from '../../Components/CustomHooks/useSearchExecutor';
import useNavigation from '../../Utility/hooks/useNavigation';
import './Customer.css';

const CustomerPage = ({ isCustomerscreen = true,handleOpenCsvpop }) => {
  const isLoadingProgress = useSelector(state => state?.global?.isLoading);
  const [dataGridData, setDatagridData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [selectionModel, setSelectionModel] = React.useState([]);
  const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData); 
  const pagedCustomersData = useSelector(state => state?.customer?.pagedCustomers)
  const dispatch = useDispatch();
  const today = new Date();
  const daysAgo = new Date();
    daysAgo.setDate(today.getDate() - 180)
  const customerSearch = useSelector((state) => (state.search.customer));
    const handleChangeSearchField = (event) => {
        dispatch(setSearch(searchEntity?.customer, {
                    ...customerSearch,
                    [event.target.name]: event.target.value,
                }));
    }
    
  const ownerlist = useSelector(state => state?.owner?.ownerlist);  
  const [ownerlistdropdown, setownerlistdropdown] = useState([]);
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);

    const { navigateTo } = useNavigation();
    const customerTextfieldsData = useMemo(() => {
        const data = getEntityColumns(allEntityData, "CUSTOMER");
        return Object.keys(data).length > 0 ?  data : STATIC_ENTITY_CONFIG?.CUSTOMER;
    }, [allEntityData]);

  useEffect(() => {
    const ownerlistdata = ownerlist.map(item => {
      return {
        name: `${item?.firstName} ${item?.lastName}`, 
        id: item?.id
      }
    })
    setownerlistdropdown(ownerlistdata);
  },[ownerlist])
  
const preserveSearch = useSelector(
  state => state?.search?.preserveSearch?.[searchEntity?.customer]
);
const getInitialState = () => ({
    updatedFrom: dateFormatting(daysAgo),
    updatedTo: dateFormatting(today),
    priceFrom: "",
    priceTo: "",
    pocPhoneCountryCode: phoneCountryCodes?.pocPhoneCountryCode,
});
useEffect(() => {
    if (pagedCustomersData?.content && pagedCustomersData.content.length > 0) {
        const updatedCustomerTable = pagedCustomersData.content.map((item) => {
            const countryCode = item?.phoneCountryCode || "";
            const phone = item?.phone || "";

            return {
                ...item,
                phone: countryCode && phone ? `${countryCode}${phone}` : "",
            };
        });

        setDatagridData(updatedCustomerTable);
    } else {
        setDatagridData([]);
    }
}, [pagedCustomersData]);


  const handleEditCustomer = useCallback((id, value) => () => {
    navigateTo(`${privateRoutesPath.EDIT_CUSTOMER}/${id}`, { 
      isViewMode: value,
    }, searchEntity?.customer);
  }, [navigateTo]);

  const columns = useMemo(() => [
    {
      field: 'id',
      headerName: handleValidateCodevalue(internationalise,'CUST_SEARCH_CUSTOMER_ID'),
      flex: 1,
      minWidth : customerIdWidth,
      editable: false,
      renderCell: ({id}) => (
      isCustomerscreen ? <span
      onClick={handleEditCustomer(id,true)}
      className="customer-table-clickable-id"
    >
      {id}
    </span>
    : 
    <span>
      {id}
    </span>
      )
    },
    {
      field: 'firstName',
      headerName: handleValidateCodevalue(internationalise,'CUST_SEARCH_FIRSTNAME'),
      flex: 1,
      minWidth : nameWidth,
      editable: true,
    },
    {
      field: 'lastName',
      headerName: handleValidateCodevalue(internationalise,'CUST_SEARCH_LASTNAME'),
      flex: 1,
      minWidth : nameWidth,
      editable: true,
    },
    {
      field: 'phone',
      headerName: handleValidateCodevalue(internationalise,'COMMON_PHONE_NUMBER'),
      flex: 1,
      minWidth : phoneWidth,
      editable: false,
    },    {
      field: 'email',
      headerName: handleValidateCodevalue(internationalise,'COMMON_EMAIL_ID'),
      flex: 1,
      minWidth : emailWidth,
      editable: true,
    },   
    {
      field: 'status',
      headerName: handleValidateCodevalue(internationalise,'CUST_SEARCH_STATUS'),
      flex: 1,
      minWidth : statusWidth,
      editable: false,
      valueGetter:({value})=>{
        if(!value){
          return ""
        }
          return handleValidateCodevalue(internationalise,value)
        }
    },
    {field: 'totalValue',
      headerName:  handleValidateCodevalue(internationalise,'CUST_SEARCH_TOTAL_VALUE'),
      flex: 1,
      editable: false ,
      minWidth: statusWidth,
    },
    {
      field: 'createdAt',
      headerName: handleValidateCodevalue(internationalise,'COMMON_CREATED_AT'),
      type: 'date',
      flex: 1,
      minWidth : whocolumnWidth,
      editable: false,
      valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
    },
    {
      field: 'updatedAt',
      type: 'date',
      headerName: handleValidateCodevalue(internationalise,'COMMON_UPDATED_AT'),
      flex: 1,
      minWidth : whocolumnWidth,
      editable: false,
      valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
    },
  ], [
    internationalise,
    handleEditCustomer,
    isCustomerscreen,
    customerIdWidth,
    nameWidth,
    phoneWidth,
    emailWidth,
    statusWidth,
    whocolumnWidth,
  ]);

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = dataGridData.find((row) => row.id === id);
    if (editedRow.isNew) {
      setDatagridData(dataGridData.filter((row) => row.id !== id));
    }
  };
  
   const {buildSearchParams,executeSearch} = useSearchExecutor({
      ownerlist,
      enqueueSnackbar,
      internationalise,
      handleValidateCodevalue,
    });

const {
  paginationState,
  search: handleSearchCustomerPaged,
  changePage: handlePageChange,
  changePageSize: handlePageSizeChange,
} = usePaginatedSearch({
  entity: searchEntity?.customer,
  searchState: customerSearch,
  getInitialState: getInitialState,
  preserveSearch,
  isReady : true,
  buildParams: (overrideSearch) => buildSearchParams(overrideSearch ?? customerSearch),
  executeSearch,
  searchAction: requestGetCustomersPaged,
});

  const handleUpdateCustomer = async(rowRecord) => {
    if(!isValidEmail(rowRecord?.email)){
    enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_VALID_EMAIL"),{variant:'error'});
    return;
    }
    const Id = rowRecord?.id;
    dispatch(requestShowLoader());
            const url = `${process.env.REACT_APP_BASE_URL}customers/${Id}`;
            const responseData = await updateRequestData(rowRecord, url);
            if(responseData?.status == 200) {
              enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_UPDATED_SUCCESSFULLY'), {variant: 'success'});
              
              handleSearchCustomerPaged(0)
              dispatch(requestHideLoader());
            }
            if(responseData?.propererror){
                enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), {variant : 'error'});
                dispatch(requestHideLoader());
            }
  }
    const handleResetSearch = () => {
      dispatch(
          setSearch(searchEntity?.customer,resetState(customerSearch, {
            pocPhoneCountryCode: phoneCountryCodes?.pocPhoneCountryCode,
          })
        )
      );
    };

    
    const customerSearchBox = {
        ...customerSearch,
    }

    const processRowUpdate = (newRow, oldRow) => {
        if(JSON.stringify(newRow) == JSON.stringify(oldRow)) {
          enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_NO_DATA_CHANGED'), {variant: 'info'});
        } else {
          handleUpdateCustomer(newRow); 
        }
    const updatedRow = { ...newRow, isNew: false };
    setDatagridData(dataGridData.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

       const handleNotifyCustomerFromLeadPage = async(selectedCustomers) => {

                setIsOpenNotificationDialog({
                ...isOpenNotificationDialog,
                selectedDetails : selectedCustomers,
                isOpen : true,
              });
          }
          const [isOpenNotificationDialog,setIsOpenNotificationDialog] = useState({
              isOpen : false,
              selectedDetails : []
          })
          

  return (
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
    <StyledDiv>
      {isCustomerscreen && <StyledLeadContainer>
        <Typography variant='h6' className='mb-20'>
        {handleValidateCodevalue(internationalise,'CUST_SEARCH_TITLE')}
        </Typography>
        <Stack spacing={2} direction="row">
        
        </Stack>
      </StyledLeadContainer>}
      {/* <SearchCustomer 
        handleSearchCustomer={handleSearchCustomer}
      /> */}
      <StyledIndexContainerDiv>
         {isCustomerscreen &&
        <StyledLeadContainer className="customer-filter-container">
            <Stack className='table-header-search table-header-search-common'>      
               
                <BiztantuSearch
                  showStatus = {false}
                  entityDetails = {customerSearchBox}
                  ownerlistdropdown = {ownerlistdropdown}
                  handleReset = {handleResetSearch}
                  handleSearch = {()=>handleSearchCustomerPaged(0)}               
                >
                  <SearchCustomer
                    entityDetails = {customerSearch}
                    handleOnChange = {handleChangeSearchField}
                    handleResetSearch = {handleResetSearch}

                  />
                </BiztantuSearch>
            </Stack>
              <Stack className='secondry-btn-container' width="60%" padding="10px" justifyContent="flex-end" spacing={2} direction="row">
                  
            {specificRolePermission?.isCustomerManage &&
                  <Button className='biztantu-sec-btn' variant="outlined" onClick={() =>
                      navigateTo(privateRoutesPath.CREATE_CUSTOMER,{},searchEntity?.customer)
                  }
                  >
                    {handleValidateCodevalue(internationalise,'CUST_CREATE')}
                  </Button>}
              </Stack>
        </StyledLeadContainer>
}
      <DataGridTable
        isCheckboxReq= {false}
        entityTextfieldsData={customerTextfieldsData}
        isNotificationScreen = {!isCustomerscreen}
        dataGridData={dataGridData}
        height={"calc(100vh - 218px)"}
        filename="customer"
        isCustomerscreen = {isCustomerscreen}
        selectionModel={selectionModel}
        setSelectionModel={(data) => setSelectionModel(data)}
        columns={columns}
        pagedData={pagedCustomersData}
        paginationState={paginationState}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        rowModesModel={rowModesModel}
        handleProcessRowUpdate={processRowUpdate}
        handleUpdateProduct={handleUpdateCustomer}
        handleNotifyCustomer = {() => handleNotifyCustomerFromLeadPage( selectionModel)}
      />
      </StyledIndexContainerDiv>
      {
        (isOpenNotificationDialog?.isOpen) && (
          <SendNotification
            open={isOpenNotificationDialog?.isOpen}
            title= {handleValidateCodevalue(internationalise,"COMMON_NOTIFY_CUSTOMER")}
            selectedDetails={isOpenNotificationDialog?.selectedDetails}
            setIsOpenNotificationDialog = {setIsOpenNotificationDialog}
            type = {"Customer"}
          />
        )
      }
    </StyledDiv>
    </BiztantuLoader>
  )
}

export default CustomerPage;